import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { footerObj, footerLogo, customEnamad } from './footerData';
import './footer.scss';
// importing svg-components
import {
  InfoCircleIcon,
  ScaleIcon,
  HeadsetIcon,
  WhatsappIcon,
  InstagramIcon,
  LinkedInIcon,
  YouTubeIcon,
  TelegramIcon,
} from '~svg/index';
import { FacebookIcon } from '../../../content/svg-component/social-media/facebookIcon';

// Import all required images
import mirasLogo from '../../../content/images/elements/miras.png';
import kasbLogo from '../../../content/images/elements/kasb.png';
import stateAirlineLogo from '../../../content/images/elements/state-airline.317506d.svg';
import airaTicketLogo from '../../../content/images/elements/aira-ticket-price.png';
import passengerRightsLogo from '../../../content/images/elements/passenger-rights.9eea7f0.svg';
import samandehiLogo from '../../../content/images/elements/samandehi.png';
import namadLogo from '../../../content/images/elements/namad.png';

const Footer = () => {
  const urlLocation = window.location.host;
  
  const getLogoImage = (name) => {
    switch(name) {
      case 'miras.png':
        return mirasLogo;
      case 'kasb.png':
        return kasbLogo;
      case 'state-airline.317506d.svg':
        return stateAirlineLogo;
      case 'aira-ticket-price.png':
        return airaTicketLogo;
      case 'passenger-rights.9eea7f0.svg':
        return passengerRightsLogo;
      case 'samandehi.png':
        return samandehiLogo;
      case 'namad.png':
        return namadLogo; 
      default:
        return null;
    }
  };

  const RenderItem = ({ name, value, link }) => {
    if (value) {
      return (
        <div
          className={`${
            value.includes('phone')
              ? 'd-flex flex-column justify-content-start'
              : 'col-9 p-0 text-start'
          } `}
        >
          <FormattedMessage id={`${name}`} children={(msg) => <>{msg}</>} />
          <span className={`pt-2 px-1`}></span>
          <FormattedMessage id={value} children={(msg) => <>{msg}</>} />
        </div>
      );
    } else if (link) {
      return (
        <Link className="text-third" to={link}>
          <FormattedMessage id={`${name}`} children={(msg) => <>{msg}</>} />
        </Link>
      );
    } else {
      return <FormattedMessage id={`${name}`} children={(msg) => <>{msg}</>} />;
    }
  };
  const RenderFooterLogo = ({
    name,
    link = '',
    imgClass = '',
    id = '',
    isonline = false,
  }) => {
    const logoImage = getLogoImage(name);
    
    return (
      <a
        className="logo-div m-1 shadow bg-white shadow rounded"
        href={link}
        target="_blank"
      >
        <img
          className={`${imgClass}`}
          src={isonline ? name : logoImage}
          width="80px"
          height="50px"
          alt="logo"
          id={id}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </a>
    );
  };
  return (
    <footer className="footer p-4 font-small bg-third-light border-top d-md-block d-none d-sm-none">
      <div className="px-2 py-4 d-flex flex-wrap text-third text-start">
        <nav className="d-flex justify-content-between col-8 p-0">
          {/* Who we are  */}
          <div className={`px-2 col-4 d-flex flex-column align-items-start`}>
            <h4 className="pb-2 text-primary d-flex align-items-center font-normal font-weight-normal font-lg-large ">
              <InfoCircleIcon size={20} color="#3d4a8f" className="" />
              <span className="px-1">
                <FormattedMessage
                  id="footer.who"
                  children={(msg) => <>{msg}</>}
                />
              </span>
            </h4>
            <ul className="m-0 p-0 font-msmall font-lg-small">
              {footerObj['who'].map((item, index) => {
                const { name, value, link } = item;
                return (
                  <li key={`item-${index}`} className="py-1">
                    <RenderItem name={name} value={value} link={link} />
                  </li>
                );
              })}
            </ul>
          </div>
          {/* Rules */}
          <div className={`px-2 col-4 d-flex flex-column align-items-start`}>
            <h4 className=" pb-2 text-primary d-flex align-items-center font-normal font-lg-large">
              <ScaleIcon size={20} color="#3d4a8f" />
              <span className="px-2">
                <FormattedMessage
                  id={`footer.rules`}
                  children={(msg) => <>{msg}</>}
                />
              </span>
            </h4>
            <ul className="m-0 p-0 font-msmall font-lg-small">
              {footerObj['rules'].map((item, index) => {
                const { name, value, link } = item;
                return (
                  <li key={`item-${index}`} className="py-1 ">
                    <RenderItem name={name} value={value} link={link} />
                  </li>
                );
              })}
            </ul>
          </div>
          {/* Our Supports */}
          <div className={`px-2 col-4 d-flex flex-column align-items-start`}>
            <h4 className="pb-2 text-primary d-flex align-items-center font-normal font-lg-large">
              <HeadsetIcon size={18} color="#3d4a8f" />
              <span className="px-2">
                <FormattedMessage
                  id={`footer.supports`}
                  children={(msg) => <>{msg}</>}
                />
              </span>
            </h4>
            <ul className="m-0 p-0 font-msmall font-lg-small">
              {footerObj['supports'].map((item, index) => {
                const { name, value, link } = item;
                return (
                  <li key={`item-${index}`} className="py-1 diasable">
                    <RenderItem name={name} value={value} link={link} />
                  </li>
                );
              })}
            </ul>
          </div>
        </nav>
        {/* Map */}
        <div className="d-flex align-items-start justify-content-end col-4 px-0">
          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1764.4621117533657!2d51.41351423509444!3d35.799004156647555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e061782b51c75%3A0xdb7b7317d43aa3b3!2sTehran%20Province%2C%20Tehran%2C%20District%201%2C%20Moqadas%20Ardabili%20St%2C%20Iran!5e0!3m2!1sen!2s!4v1633501708532!5m2!1sen!2s"
            width="100%"
            height="109"
            className="rounded border-0 shadow col-6 p-0"
            loading="lazy"
          /> */}
          {/* Logo */}
          <div
            className={`${
              urlLocation.includes('tripord') ? 'd-none' : 'd-flex'
            } flex-row justify-content-end flex-wrap`}
          >
            {footerLogo.map((logo, logoIndx) => {
              return (
                <RenderFooterLogo
                  key={`logo-${logoIndx}`}
                  name={logo.name}
                  link={logo.link}
                  imgClass={logo.imgClass}
                  isonline={logo.isonline}
                  id={logo.id ? logo.id : `logoID-${logoIndx}`}
                />
              );
            })}
            {/* <img
              referrerPolicy="origin"
              id="307763&amp;amp;Code=DPVNteZjwOo6xM5cG84m"
              style={{ cursor: "pointer", width: 50, height: 50 }}
              onClick={
                () =>
                  window.open(
                    "https://trustseal.enamad.ir/?id=307763&amp;amp;Code=DPVNteZjwOo6xM5cG84m",
                    "Popup",
                    "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                  )
                // 'window.open(, "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
              }
              alt="enamd"
              src={
               require("../../../content/images/elements/enamd.png")
              }
            /> */}
          </div>
        </div>
        {/* address */}
        <address className="px-2 pt-4 m-0 ">
          {/* <FormattedMessage
            id="footer.address"
            children={(msg) => <>{msg}</>}
          />
          <span className="px-1">:</span> */}
          <span className=" px-1">
            <FormattedMessage id="profile.address" />
            <span className="px-1">{':'}</span>
            <FormattedMessage
              id={`${
                urlLocation.includes('tripord')
                  ? 'aboutus.canadaaddress'
                  : 'aboutus.address'
              }`}
              children={(msg) => <>{msg}</>}
            />
          </span>
        </address>
      </div>
      {/* socialNetwork */}
      <div className="d-flex w-100 justify-content-center align-items-center pt-4 border-top">
        <div className="mx-2 cursor-pointer">
          <a
            href="https://www.instagram.com/toloutravel"
            aria-label="toloutravel instagram account"
          >
            <InstagramIcon size={17} color="#3d4a8f" />
          </a>
        </div>
        <div className="mx-2 cursor-pointer">
          <a
            href="https://t.me/toloutravelagent"
            aria-label="toloutravel telegram account"
          >
            <TelegramIcon size={17} color="#3d4a8f" />
          </a>
        </div>
        <div className="mx-2 cursor-pointer">
          <a
            href="https://www.youtube.com/@toloutravelagency"
            aria-label="toloutravel youtube account"
          >
            <YouTubeIcon size={17} color="#3d4a8f" />
          </a>
        </div>

        <div className="mx-2 cursor-pointer">
          <a
            href="https://m.facebook.com/profile.php?id=100093603915554"
            aria-label="toloutravel facebook account"
          >
            <FacebookIcon size={17} color="#3d4a8f" />
          </a>
        </div>
        <div className="mx-2 cursor-pointer">
          <a
            href="https://www.linkedin.com/in/tolou-travel-10088a25a/"
            aria-label="toloutravel linkedin account"
          >
            <LinkedInIcon size={17} color="#3d4a8f" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
